module.exports = ".panel .panel-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/orderlst/orderlst.component.scss
// module id = ./src/app/pages/orderlst/orderlst.component.scss
// module chunks = main